import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import LoginComponent from "../../../components/authentication/login";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { loginApi } from "../../../services/auth.service";

interface LoginContainerInterface { }

const LoginContainer: React.FC<LoginContainerInterface> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const onFinish = (val: any) => {
    setSubmitting(true);
    dispatch(
      loginApi({
        data: val,
        finalCallback: () => {
          setSubmitting(false);
        },
        successCallback: () => {
          navigate("/");
        },
        failureCallback: (val: any) => {
          // setLoginErrors(val);
        },
      })
    );
  };

  return <LoginComponent onFinish={onFinish} />;
};

export default LoginContainer;
